import styles from "@src/app/components/_ads/Taboola/Taboola.css?url";
import { useEffect } from "react";
import type { LinksFunction } from "react-router";

// const baseUrl = import.meta.env.VITE_BFF_ENDPOINT;

export const TaboolaLinks: LinksFunction = () => [
  { rel: "stylesheet", href: styles },
];

export default function Taboola({
  articleDetailId,
  urlPath,
  ref,
}: {
  articleDetailId?: string;
  urlPath?: string;
  ref?: React.RefObject<HTMLDivElement> | null;
}) {
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const loadOnceScript = document.createElement("script");
    loadOnceScript.type = "text/javascript";
    loadOnceScript.innerHTML = `window._taboola = window._taboola || [];
      !function (e, f, u, i) {
        if (!document.getElementById(i)) {
          e.async = 1;
          e.src = u;
          e.id = i;
          e.onerror = function () {
            var fallbackId = i + '_fb';

            if (document.getElementById(fallbackId)) {
              e.parentNode.removeChild(e);
              return;
            }

            var fallback = document.createElement('script');
            fallback.async = 1;
            fallback.src = 'https://static.tblcontent.com/libtrc/sphmedia-thinkchina/loader.privacy.js';
            fallback.id = fallbackId;
            e.parentNode.replaceChild(fallback, e);
          };
          f.parentNode.insertBefore(e, f);
        }
      }(document.createElement('script'),
        document.getElementsByTagName('script')[0],
        'https://cdn.taboola.com/libtrc/sphmedia-thinkchina/loader.js',
        'tb_loader_script');

      if (window.performance && typeof window.performance.mark == 'function'){
        window.performance.mark('tbl_ic');
      }
      `;
    document.head.appendChild(loadOnceScript);
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const script = document.createElement("script");
    script.id = "taboola-script";
    script.type = "text/javascript";
    script.innerHTML = `
      window._taboola = window._taboola || [];
    `;

    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    window._taboola = window._taboola || [];
    window._taboola.push({
      article: "auto",
      // url: `${baseUrl}${urlPath}`,
    });

    window._taboola.push({
      mode: "thumbnails-base-widget",
      container: "below-article-thumbnails",
      placement: "Below Article Thumbnails",
      target_type: "mix",
    });
    window._taboola.push({ flush: true });
  }, [urlPath, articleDetailId]);

  return <div ref={ref} id={"below-article-thumbnails"} className="taboola" />;
}
